export default function promisify(resolved, rejected) {
    return new Promise((resolve, reject) => {
        resolve(resolved);
        if (rejected) {
            reject(rejected);
        }
    });
}
//# sourceMappingURL=promisify.js.map